import { Box } from "@mui/material";

interface ImageDetailProps {
  imageUrl: string;
  altText?: string;
}

const ImageDetail = ({ imageUrl, altText }: ImageDetailProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        className="bannerImge"
        src={imageUrl}
        alt={altText ? altText : "Alternative Text"}
      />
    </Box>
  );
};

export default ImageDetail;
